<template>
    <div class="upload-btn">
        <button class="btn" @click="handleUpload">上传</button>
        <Form
            v-if="visible"
            :type.sync="newType"
            :visible.sync="visible"
            :isPlat.sync="isPlat"
            @success="$emit('success')"
        />
        <slot></slot>
    </div>
</template>

<script>
    import Form from './components/form'
    export default {
        name: "upload-btn",
        components: {
            Form
        },
        props: {
            type: String,
            isPlat: {
                type: Boolean,
                default: false
            }
        },
        watch:{
            type(vl){this.newType = vl},
            newType(vl){this.$emit('update:type', vl)}
        },
        data(){
            return {
                newType: this.type,
                visible: false
            }
        },
        methods: {
            handleUpload(){
                this.visible = true
            }
        }
    }
</script>

<style lang="scss" scoped>
.upload-btn {
    display: flex;
    flex-direction: row;
    padding: 0px 10px;
    width: calc(100% - 20px);

    .btn {
        width: 100%;
        font-size: 14px;
        border: none;
        color: #323232;
        margin: 10px;
        margin-top: 0px;
        line-height: 40px;
        outline: none;
        cursor: pointer;
        color: #e7622e;

        width:261px;
        height:40px;
        background:rgba(255, 120, 56,0.1);
        border-radius:4px;
        border:1px solid rgba(255, 120, 56,0.3);
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        & .add-ico{
          font-size: 20px;
        }

        &:active {
            opacity: .8;
        }
    }
}
</style>
